<div class="page-headline">
  <ng-container>
    @if (showBackButton()) {
      <button
        class="back-button"
        (click)="navigateBack()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    }
    @if (breadcrumbTexts()?.length > 0) {
      <div
        class="breadcrumbs"
        [class.no-tabs]="!tabs.length">
        @for (item of breadcrumbTexts(); track item; let isLast = $last; let isFirst = $first) {
          @if (isFirst) {
            <h3>{{ item }}</h3>
          }
          @if (!isFirst) {
            <h4>{{ item }}</h4>
          }
          @if (!isLast) {
            <mat-icon>navigate_next</mat-icon>
          }
        }
      </div>
    }
    @if (tabs.length > 0) {
      <div class="tabs">
        <coin-v2-routed-tabs
          type="primary"
          queryParamsHandling="merge"
          [defaultToFirstTab]="defaultToFirstTab()"
          (tabSelected)="onTabChange($event)">
          @for (tab of tabs; track tab) {
            <ng-template
              [coinTab]="tab.name | translate"
              [route]="tab.route"
              [isDisabled]="tab.isDisabled"
              [disabledTooltip]="tab.tooltip | translate"></ng-template>
          }
        </coin-v2-routed-tabs>
      </div>
    }
    <ng-template *ngTemplateOutlet="rightTemplate()"></ng-template>
  </ng-container>
  @if (breadcrumbTexts()?.length === 0 && headline()) {
    <h3 class="headline">{{ headline() }}</h3>
  }
  @if (headerPortalService.template()) {
    <ng-container *ngTemplateOutlet="headerPortalService.template()" />
  }
  @if (showInformation()) {
    <admin-view-information [translationPrefix]="helpTranslationKeyPrefix()"></admin-view-information>
  }
</div>
